export enum ApiService {
    Account = 'account',
    Avatars = 'avatars',
    Databases = 'databases',
    Locale = 'locale',
    Health = 'health',
    Storage = 'storage',
    Teams = 'teams',
    Users = 'users',
    Functions = 'functions',
    Graphql = 'graphql',
    Messaging = 'messaging',
}